__turbopack_context__.v({
  "dropdown": "nav-module__SXT5SW__dropdown",
  "dropdown_action": "nav-module__SXT5SW__dropdown_action",
  "dropdown_action_icon": "nav-module__SXT5SW__dropdown_action_icon",
  "dropdown_action_value": "nav-module__SXT5SW__dropdown_action_value",
  "dropdown_background": "nav-module__SXT5SW__dropdown_background",
  "link": "nav-module__SXT5SW__link",
  "link_scrolled": "nav-module__SXT5SW__link_scrolled",
  "nav": "nav-module__SXT5SW__nav",
  "nav__links": "nav-module__SXT5SW__nav__links",
  "nav__logo": "nav-module__SXT5SW__nav__logo",
  "nav__logo_image": "nav-module__SXT5SW__nav__logo_image",
  "nav_content": "nav-module__SXT5SW__nav_content",
  "scrolled": "nav-module__SXT5SW__scrolled",
  "user_info": "nav-module__SXT5SW__user_info",
  "user_info_loading": "nav-module__SXT5SW__user_info_loading",
});
